'use strict';

function alignRichTextListMarker() {

	document.querySelectorAll('.block ul li').forEach(function(li) {
		const liFontSizeStr = getComputedStyle(li).fontSize;
		const baseFontSize = parseFloat(liFontSizeStr); 
		const firstChild = li.firstElementChild;
		
		const bullet = document.createElement('span');
			bullet.textContent = '•';
			bullet.style.position = 'absolute';
			bullet.style.left = '0.5em';
			bullet.style.lineHeight = `${baseFontSize * 1.5}px`;

		li.style.listStyle = 'none';
	
		if (firstChild) {
		
			const computedFontSize = parseFloat(getComputedStyle(firstChild).fontSize);
		
			if (computedFontSize > baseFontSize) {
				li.style.position = 'relative';
			
				bullet.style.lineHeight = `${computedFontSize * 1.5}px`;
				bullet.style.fontSize = `${baseFontSize}px`;
				bullet.style.color = 'currentColor';
			}

		}

		li.prepend(bullet);
  	});
}

var init = function() {

    alignRichTextListMarker();

};

module.exports = {
	init: init
};